import React from 'react';
import { IorganizationBusinessData } from '../../../../../types/bussines';
import PlanType from './components/PlanType';
import KamClient from './components/KamClient';
import TagFiltering from '../OrgDataSection/components/TagFiltering/TagFiltering';
import ClientType from './components/ClientType';
import './OrgDataAccount.scss';

const OrgDataAccount = ({
  organizationData,
  updateWithoutLoaders
}: {
  organizationData: IorganizationBusinessData;
  updateWithoutLoaders?: () => void;
}) => {
  const { id } = organizationData;
  const organizationId = id.toString();
  return (
    <div id="orgDataAccount">
      <ClientType organizationId={organizationId} updateWithoutLoaders={updateWithoutLoaders} />
      <div className="divider" />
      <PlanType organizationId={organizationId} updateWithoutLoaders={updateWithoutLoaders} />
      <div className="divider" />
      {organizationData && updateWithoutLoaders && (
        <>
          <TagFiltering organizationData={organizationData} updateWithoutLoaders={updateWithoutLoaders} />
          <div className="divider" />
        </>
      )}
      <KamClient organizationId={organizationId} />
    </div>
  );
};

export default OrgDataAccount;
